var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 16,
    rx: 3,
    fill: "#E55454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7173 12V4.72727H16.0348V10.8956H19.2379V12H14.7173ZM21.6989 4.72727V12H20.3814V4.72727H21.6989ZM24.0985 4.72727L25.9913 10.4517H26.0659L27.9551 4.72727H29.4039L26.84 12H25.2136L22.6532 4.72727H24.0985ZM30.3619 12V4.72727H35.092V5.83168H31.6793V7.80611H34.8469V8.91051H31.6793V10.8956H35.1204V12H30.3619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveRounded);
export default __webpack_public_path__ + "static/media/LiveRounded.6135263c632a4e312a8de092bceb32bd.svg";
export { ForwardRef as ReactComponent };